// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-0790b039]{height:60px;max-width:100%;margin-top:40px}.card[data-v-0790b039]{width:16%}@media (max-width:1000px){.flexbox[data-v-0790b039]{display:block}.card[data-v-0790b039]{width:100%}.responsive[data-v-0790b039]{width:auto}.content[data-v-0790b039]{display:block}}", ""]);
// Exports
module.exports = exports;
